export default "__VITE_ASSET__DcyUryau__"